<ion-card>
  <ion-card-header>
    <ion-card-title>Átsorolás</ion-card-title>
    <ion-card-subtitle>Tanuló másik osztályba — a hozzá tartozó csoportokkal együtt</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="medium" class="at-bevezeto">
      Az átjelentkeztetés eddig két képernyő két műveletéből állt: az osztálybesorolásnál
      kivenni innen, betenni oda, majd a csoportbesorolásnál végigmenni a csoportokon. A
      <b>második lépés maradt el rendszeresen</b> — és nem is látszott: a tanuló ott maradt a
      régi osztályához tartozó csoportokban (napközi, bontott óra), és úgy szerepelt a
      névsorokban, mintha még az előző osztályba járna. Itt a kettő egyben megy, és
      <b>előre látod</b>, mi fog történni.
    </ion-note>

    <div class="at-allapot hiba" *ngIf="hiba">
      <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
    </div>

    <!-- 1. Tanuló -->
    <div class="at-lepes">
      <h3><span class="at-szam">1</span> Kit sorolunk át?</h3>
      <ion-input label="Tanuló keresése" label-placement="stacked" fill="outline"
                 placeholder="név, oktatási azonosító vagy osztály"
                 [(ngModel)]="tanuloSzuro"></ion-input>
      <div class="at-talalatok" *ngIf="!valasztottTanulo">
        <button class="at-talalat" *ngFor="let t of szurtTanulok" (click)="tanuloValaszt(t)">
          <b>{{ t.nev }}</b>
          <span class="at-halvany">{{ t.oktazon }}</span>
          <span class="at-osztaly" [class.nincs]="!t.osztaly">{{ t.osztaly || 'nincs osztálya' }}</span>
        </button>
        <div class="at-ures" *ngIf="!szurtTanulok.length">Nincs találat.</div>
      </div>
      <div class="at-valasztott" *ngIf="valasztottTanulo">
        <b>{{ valasztottTanulo.nev }}</b>
        <span class="at-halvany">{{ valasztottTanulo.oktazon }}</span>
        <span class="at-osztaly" [class.nincs]="!elemzes?.jelenlegi">
          {{ elemzes?.jelenlegi?.osztaly || 'nincs osztálya' }}
        </span>
        <ion-button size="small" fill="clear" (click)="valasztottTanulo = null; elemzes = null">
          Másik tanuló
        </ion-button>
      </div>
    </div>

    <!-- 2. Célosztály + dátum -->
    <div class="at-lepes" *ngIf="valasztottTanulo">
      <h3><span class="at-szam">2</span> Hova, és mikortól?</h3>
      <div class="at-sor">
        <ion-select label="Célosztály" labelPlacement="stacked" interface="popover"
                    placeholder="válassz osztályt" [(ngModel)]="celOsztaly" (ngModelChange)="elemez()">
          <ion-select-option *ngFor="let o of osztalyok" [value]="o.id"
                             [disabled]="o.id === elemzes?.jelenlegi?.osztaly_id">
            {{ o.osztaly }}<span *ngIf="o.evfolyam"> ({{ o.evfolyam }}. évf.)</span>
          </ion-select-option>
        </ion-select>
        <ion-input label="Átsorolás napja" labelPlacement="stacked" fill="outline" type="date"
                   [(ngModel)]="datum" (ionChange)="elemez()"></ion-input>
      </div>
      <ion-note color="medium" class="at-sugo">
        A régi besorolás <b>nem törlődik</b>, csak lezárul az előző nappal — így az átsorolás
        előtti időszak adata (jegyek, hiányzás, névsorok) változatlanul visszanézhető marad.
      </ion-note>
    </div>

    <!-- 3. Csoportok -->
    <div class="at-lepes" *ngIf="valasztottTanulo && elemzes">
      <h3><span class="at-szam">3</span> Mi legyen a csoportjaival?</h3>

      <div class="at-ures" *ngIf="!elemzes.csoportok?.length">
        A tanuló jelenleg egyetlen csoportnak sem tagja.
      </div>

      <div class="at-figyelmeztetes" *ngIf="elemzes.erintett_csoport && !celOsztaly">
        <ion-icon name="warning-outline"></ion-icon>
        <span>
          <b>{{ elemzes.erintett_csoport }}</b> olyan csoportban van, amelyik a mostani
          osztályához tartozik. Válassz célosztályt, és megnézzük, hova kerüljön át.
        </span>
      </div>

      <table class="at-tabla" *ngIf="elemzes.csoportok?.length">
        <thead>
          <tr>
            <th>Csoport</th>
            <th>Miért érinti</th>
            <th>Hova kerüljön</th>
            <th>Ez fog történni</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cs of elemzes.csoportok" [class.nem-erintett]="cs.kapcsolat === 'nincs'">
            <td><b>{{ cs.name }}</b></td>
            <td>
              <span class="at-jel" [class.kotes]="cs.kapcsolat === 'kotes'"
                    [class.nev]="cs.kapcsolat === 'nev'">{{ kapcsolatSzoveg(cs) }}</span>
            </td>
            <td>
              <ion-select interface="popover" [(ngModel)]="dontes[cs.id]" placeholder="—"
                          [disabled]="!celOsztaly">
                <ion-select-option value="">— nem sorolom át —</ion-select-option>
                <ion-select-option *ngIf="cs.javasolt" [value]="cs.javasolt.id">
                  {{ cs.javasolt.name }} (javasolt)
                </ion-select-option>
                <ion-select-option *ngFor="let h of cs.hasonlok" [value]="h.id">{{ h.name }}</ion-select-option>
              </ion-select>
              <div class="at-nincspar" *ngIf="celOsztaly && cs.kapcsolat !== 'nincs' && !cs.javasolt">
                Nincs egyértelmű párja. Várt név: <b>{{ cs.varhato_nev }}</b>
                <span *ngIf="!cs.hasonlok?.length"> — hasonló nevű csoport sincs a célosztály tanévében.</span>
              </div>
            </td>
            <td>
              <ion-checkbox *ngIf="!dontes[cs.id]" [(ngModel)]="lezar[cs.id]" labelPlacement="end"
                            [disabled]="!celOsztaly">
                kilépjen a csoportból
              </ion-checkbox>
              <span class="at-hatas" *ngIf="dontes[cs.id]">{{ hatasSzoveg(cs) }}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <ion-note color="medium" class="at-sugo">
        Csoportot a rendszer <b>nem hoz létre</b> magától, és nem sorol át semmit kérdés nélkül.
        Ami „nem az osztályhoz tartozik", ahhoz alapból nem nyúlunk — az a tanuló saját
        csoportja (pl. fejlesztő), ami az osztályváltástól még megmarad.
      </ion-note>
    </div>

    <!-- 4. Végrehajtás -->
    <div class="at-lab" *ngIf="valasztottTanulo && elemzes">
      <div class="at-osszegzo">
        <span *ngIf="!celOsztaly">Válassz célosztályt a folytatáshoz.</span>
        <span *ngIf="celOsztaly">
          <b>{{ elemzes?.jelenlegi?.osztaly || 'nincs osztálya' }}</b> →
          <b>{{ celOsztalyNev }}</b>, {{ datum }}-tól.
          <span *ngIf="valtozoCsoport">{{ valtozoCsoport }} csoporttagság is változik.</span>
          <span *ngIf="!valtozoCsoport">Csoporttagság nem változik.</span>
        </span>
      </div>
      <ion-button color="primary" [disabled]="!celOsztaly || fut" (click)="vegrehajt()">
        <ion-icon slot="start" name="swap-horizontal-outline"></ion-icon>
        {{ fut ? 'Átsorolás…' : 'Átsorolás végrehajtása' }}
      </ion-button>
    </div>
  </ion-card-content>
</ion-card>

<!-- ══════════════════════════════════════════════════════════════════════════
     HAMIS HIÁNYZÁS — külön művelet, külön kártya.

     A besorolás javítása a jövőre hat; ami a rossz csoport óráin már be van
     jelölve, az ott marad. Ez itt az a kapu, amin az levehető — tételesen.
     ══════════════════════════════════════════════════════════════════════ -->
<ion-card *ngIf="valasztottTanulo && elemzes" class="at-hamis-kartya">
  <ion-card-header>
    <ion-card-title>Hamis hiányzás takarítása</ion-card-title>
    <ion-card-subtitle>Ha a tanuló olyan csoport óráin van hiányzónak jelölve, ahova nem járt</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="medium" class="at-bevezeto">
      Rossz csoportbesorolásnál a tanár <b>jogosan</b> jelölte be a hiányzást: az a tanuló
      tényleg nem volt ott. Csakhogy oda nem is tartozott — a szülő ezért látja hamis
      mulasztásnak, és az összesítő, a szülői keret és a KRÉTA-átadás is ezt viszi tovább.
      A besorolás javítása ezen nem segít, mert az csak <b>előre</b> hat.
      <br><b>Itt semmi nem történik magától:</b> előbb megnézed a listát, és csak a
      kipipált órákról vesszük le a tanulót.
    </ion-note>

    <div class="at-sor">
      <ion-select label="Melyik csoport óráin?" labelPlacement="stacked" interface="popover"
                  placeholder="válassz csoportot" [(ngModel)]="hamisCsoport"
                  (ngModelChange)="hamisLeker()">
        <ion-select-option *ngFor="let cs of elemzes?.csoportok" [value]="cs.id">
          {{ cs.name }}
        </ion-select-option>
      </ion-select>
      <ion-input label="Ettől" labelPlacement="stacked" fill="outline" type="date"
                 [(ngModel)]="hamisTol" (ionChange)="hamisLeker()"></ion-input>
      <ion-input label="Eddig" labelPlacement="stacked" fill="outline" type="date"
                 [(ngModel)]="hamisIg" (ionChange)="hamisLeker()"></ion-input>
    </div>

    <div class="at-allapot" *ngIf="hamisCsoport && hamis && hamis.elo_tagsag">
      <ion-icon name="information-circle-outline"></ion-icon>
      <span>
        A tanulónak <b>élő tagsága van</b> ebben a csoportban
        ({{ hamis.elo_tagsag.kezdete || '?' }}-tól). A hiányzások levétele önmagában
        félmunka: a <b>besorolást is rendezni kell</b>, különben a következő órán újra
        bejelölik.
      </span>
    </div>

    <ng-container *ngIf="hamisCsoport && hamis">
      <div class="at-ures" *ngIf="!hamis.orak?.length">
        Ebben a csoportban (és időszakban) nincs hiányzása. Nincs mit takarítani.
      </div>

      <ng-container *ngIf="hamis.orak?.length">
        <div class="at-hamis-osszegzo">
          <span><b>{{ hamis.orak.length }}</b> óra</span>
          <span *ngIf="hamis.igazolt">{{ hamis.igazolt }} igazolt</span>
          <span *ngIf="hamis.igazolatlan" class="rossz">{{ hamis.igazolatlan }} igazolatlan</span>
          <span *ngIf="hamis.elbiralatlan">{{ hamis.elbiralatlan }} elbírálatlan</span>
          <span class="at-halvany">összesen {{ hamis.osszes_ora }} mulasztott óra</span>
        </div>

        <div class="at-hamis-gombsor">
          <ion-button size="small" fill="outline" (click)="hamisMind(true)">Mind</ion-button>
          <ion-button size="small" fill="clear" (click)="hamisMind(false)">Egyik sem</ion-button>
        </div>

        <table class="at-tabla">
          <thead>
            <tr>
              <th></th><th>Dátum</th><th>Óra</th><th>Tantárgy</th><th>Állapot</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let o of hamis.orak" [class.jelolt]="hamisJelolt[o.id]">
              <td><ion-checkbox [(ngModel)]="hamisJelolt[o.id]"></ion-checkbox></td>
              <td>{{ o.datum }}</td>
              <td>{{ o.ora }}.<span *ngIf="o.hossz > 1">–{{ o.ora + o.hossz - 1 }}.</span></td>
              <td>{{ o.tantargy || '—' }}</td>
              <td [class.rossz]="o.igazolas_allapot === 'igazolatlan'">
                {{ allapotSzoveg(o) }}
                <span class="at-halvany" *ngIf="o.nem_tanorai">· nem tanórai, nem számít</span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="at-lab">
          <div class="at-osszegzo">
            <span *ngIf="!hamisJeloltDb">Pipáld ki, melyik órákról vegyük le.</span>
            <span *ngIf="hamisJeloltDb">
              <b>{{ hamisJeloltDb }}</b> óra hiányzás-jelölése törlődik. A hiányzás
              <b>ténye</b> tűnik el, nem csak az igazolása.
            </span>
          </div>
          <ion-button color="danger" [disabled]="!hamisJeloltDb || hamisFut" (click)="hamisTorol()">
            <ion-icon slot="start" name="trash-outline"></ion-icon>
            {{ hamisFut ? 'Törlés…' : 'Kijelölt hiányzások levétele' }}
          </ion-button>
        </div>
      </ng-container>
    </ng-container>
  </ion-card-content>
</ion-card>
